import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    HostBinding,
    inject,
    OnInit,
    signal,
    ViewEncapsulation
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
    DigitalClientCardTypeQuery,
    DCLGarageUseTypeQuery,
    DCLParkingCarWashUseTypeQuery,
    DCLRentalUseTypeQuery,
    BranchTypeQuery,
    DigitalClientCardTypeFormGroup,
    DigitalClientCardTypeFormGroupSelector,
    BranchTypeFormGroupSelector,
    DigitalClientCardType,
    CustomerTypeFormGroupSelector,
    DCLResponseTypeQuery,
    InvoiceTypeQuery,
    ProviderResponseTypeQuery,
    DCLResponseTypeFormGroupSelector,
    InvoiceTypeFormGroupSelector,
    DigitalClientCardGraphQLSchemaActions,
    DigitalClientCardGraphQLSchemaSelectors,
    DigitalClientCardInputType,
    ProviderResponseErrorTypeQuery,
    ResponseTypeErrorTypeQuery,
    DCLCorrelationTypeQuery,
    UsersActionsTypeQuery,
    InvoiceType,
    POSTerminalResponseType,
    POSTerminalTransactionType,
    ProviderResponseTypeFormGroupSelector,
    ResponseTypeErrorTypeFormGroupSelector,
    CustomerType,
    EntitySubjectInfoGraphQLSchemaActions,
    EntitySubjectInfoTypeQuery,
    CustomersToEntitiesSubjectTypeQuery,
    CustomerTypeQuery,
    AddressTypeQuery,
    CityTypeQuery,
    ContactDetailTypeQuery,
    FinancialDetailTypeQuery,
    FirstNameTypeQuery,
    InfoNoteTypeQuery,
    OccupationActivityTypeQuery,
    TAXOfficeTypeQuery,
    TraderProfitMarginTypeQuery,
    EntitySubjectInfoGraphQLSchemaSelectors,
    EntitySubjectInfoType,
    CustomersToEntitiesSubjectTypeFormGroupSelector,
    EntitySubjectInfoTypeFormGroupSelector,
    BranchType
} from '@shared/zigra-schemas/zigra-schema.autogenerated.models';
import { DatePickerModule } from 'primeng/datepicker';
import {
    DialogService,
    DynamicDialogConfig,
    DynamicDialogRef
} from 'primeng/dynamicdialog';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { TextareaModule } from 'primeng/textarea';
import { ServiceRecurringComponent } from '../service-recurring-component/ServiceRecurring.component';
import { ZDclEntryDateTimeComponent } from '../../../../../shared/components/bussiness-components/z-dcl-entry-date-time/z-dcl-entry-date-time.component';
import { ZBranchSelectComponent } from '@shared/components/bussiness-components/z-branch-select/z-branch-select.component';
import { ZCarRegistrationNumberComponent } from '../../../../../shared/components/bussiness-components/z-car-registration-number/z-car-registration-number.component';
import { ZFloatLabelNotesComponent } from '../../../../../shared/components/form-components/z-float-label-notes/z-float-label-notes.component';
import { ButtonModule } from 'primeng/button';
import { DCLCardOptions } from '../../entities/dcl-card.options';
import { ZFloatLabelCurrencyComponent } from '../../../../../shared/components/form-components/z-float-label-currency/z-float-label-currency.component';
import { ZDclProvidedServiceCategorySelectorComponent } from '../z-dcl-provided-service-category-selector/z-dcl-provided-service-category-selector.component';
import { ZFloatLabelComponent } from '../../../../../shared/components/form-components/z-float-label/z-float-label.component';
import { ZCheckboxComponent } from '../../../../../shared/components/form-components/z-checkbox/z-checkbox.component';
import { ZDclOffSiteProvidedServiceSelectorComponent } from '../z-dcl-offSite-provided-service-selector/z-dcl-offSite-provided-service-selector.component';
import { concatMap, finalize, timer, Subject, takeUntil, of } from 'rxjs';
import { Store } from '@ngxs/store';
import { LoaderService } from '@shared/services/loader.service';
import { PostDCLsToAADESchema } from '@shared/zigra-schemas/custom/PostDCLsToAADE.schema.service';
import { ZDatePickerComponent } from '../../../../../shared/components/form-components/z-date-picker/z-date-picker.component';
import { ZDatePipe } from '../../../../../shared/pipes/ZDate.pipe';
import { MessageService, ToastMessageOptions } from 'primeng/api';

import { ToastModule } from 'primeng/toast';
import { ZionMessagesService } from '@shared/services/ax-messages.service';
import { InvoiceCardFooterComponent } from '@portal/invoicing/invoices-cards/components/footer/invoice-card-footer/invoice-card-footer.component';
import { InvoiceCardComponent } from '@portal/invoicing/invoices-cards/components/invoice-card/invoice-card.component';
import { InvoiceOptions } from '@portal/invoicing/invoices-cards/entities/invoice-card.options';
import { ObjectId, QueryFilter, QueryFilterGroup } from 'zigra-ng-framework';
import { DclCardService } from '@shared/services/dcl-card/dcl-card.service';
import { InvoiceCardCustomerComponent } from '@portal/invoicing/invoices-cards/components/invoice-card-customer/invoice-card-customer/invoice-card-customer.component';
import { ZCustomerSelectComponent } from '@shared/components/bussiness-components/z-customer-select/z-customer-select.component';
export const digitalClientCardFormGroupSelector =
    DigitalClientCardTypeFormGroupSelector.Selector({
        DCLNewId: true,
        DCLUpdateId: true,
        ClientServiceType: true,
        CreationDateTime: true,
        BranchAADE: true, //  Εγκατάσταση (Υποκατάστημα)
        Garage: DCLGarageUseTypeQuery.GQLQuery(),
        ParkingUse: DCLParkingCarWashUseTypeQuery.GQLQuery(),
        RentalUse: DCLRentalUseTypeQuery.GQLQuery(),

        ContinuousService: true,
        FromAgreedPeriodDate: true,
        ToAgreedPeriodDate: true,

        RecurringService: true,
        CustomerVatNumber: true,
        CustomerCountry: true,

        MixedService: true,

        Comments: true,

        CorrelatedDclId: true,

        // Update Client
        CustomerId: true,
        Customer: CustomerTypeFormGroupSelector.Selector({
            Subjects: CustomersToEntitiesSubjectTypeFormGroupSelector.Selector({
                Subject: EntitySubjectInfoTypeFormGroupSelector.Selector()
            })
        }),
        EntryCompletion: true,
        NonIssueInvoice: true,
        Amount: true,
        CompletionDateTime: true,
        IsDiffVehReturnLocation: true,
        VehicleReturnLocation: true,
        ProvidedServiceCategory: true,
        ProvidedServiceCategoryOther: true,
        InvoiceKind: true,
        OffSiteProvidedService: true, // // 16?. Παροχή Υπηρεσίων Εκτός Εγκατάστασης (OffSiteProvidedServiceType) (null = Χωρίς Μετακίνηση, 1 = Μετακίνηση σε συνεργαζόμενη οντότητα, 2 = Μετακίνηση σε εγκατάσταση εντός της ίδιας οντοτήτας)
        ExitDateTime: true,
        EntityVatNumber: true,
        CooperatingVatNumber: true, // 17?. Α.Φ.Μ Συνεργαζόμενης Οντοτητας (για το OffSiteProvidedServiceType = 2)
        OtherBranchAADE: true, // 18?. Άλλος Αρ. Εγκατάστασης εντός της ίδιας οντότητας (αλλο Branch) (για το OffSiteProvidedServiceType = 3)
        InvoiceCounterparty: true,
        InvoiceCounterpartyCountry: true,
        BranchId: true,
        BranchOtherId: true,
        Branch: BranchTypeFormGroupSelector.Selector(),
        BranchOther: BranchTypeFormGroupSelector.Selector(),
        Responses: DCLResponseTypeFormGroupSelector.Selector(),
        Invoices: InvoiceTypeFormGroupSelector.Selector({
            Response: ProviderResponseTypeFormGroupSelector.Selector({
                Errors: ResponseTypeErrorTypeFormGroupSelector.Selector()
            })
        }),
        Invoice: InvoiceTypeFormGroupSelector.Selector()
    });
export const digitalClientCardQuery: DigitalClientCardTypeQuery = {
    DCLNewId: true,
    DCLUpdateId: true,
    ClientServiceType: true,
    CreationDateTime: true,
    BranchAADE: true, //  Εγκατάσταση (Υποκατάστημα)
    Garage: DCLGarageUseTypeQuery.GQLQuery(),
    ParkingUse: DCLParkingCarWashUseTypeQuery.GQLQuery(),
    RentalUse: DCLRentalUseTypeQuery.GQLQuery(),

    ContinuousService: true,
    FromAgreedPeriodDate: true,
    ToAgreedPeriodDate: true,

    RecurringService: true,
    CustomerVatNumber: true,
    CustomerCountry: true,

    MixedService: true,

    Comments: true,

    CorrelatedDclId: true,

    // Update Client
    CustomerId: true,
    Customer: CustomerTypeQuery.GQLQuery({
        ...CustomerTypeQuery.GQLQuery(),
        Addresses: AddressTypeQuery.GQLQuery({
            City: CityTypeQuery.GQLQuery()
        }),
        FirstName: FirstNameTypeQuery.GQLQuery(),
        FatherName: FirstNameTypeQuery.GQLQuery(),
        InfoNotes: InfoNoteTypeQuery.GQLQuery(),
        OccupationActivity: OccupationActivityTypeQuery.GQLQuery(),
        ContactDetails: ContactDetailTypeQuery.GQLQuery({
            Address: AddressTypeQuery.GQLQuery({
                City: CityTypeQuery.GQLQuery()
            })
        }),
        // Courier: CourierTypeQuery.GQLQuery(),
        FinancialDetails: FinancialDetailTypeQuery.GQLQuery(),
        TraderProfitMargin: TraderProfitMarginTypeQuery.GQLQuery(),
        CTAXOffice: TAXOfficeTypeQuery.GQLQuery(),
        Subjects: CustomersToEntitiesSubjectTypeQuery.GQLQuery({
            Subject: EntitySubjectInfoTypeQuery.GQLQuery()
        })
    }),
    EntryCompletion: true,
    NonIssueInvoice: true,
    Amount: true,
    CompletionDateTime: true,
    IsDiffVehReturnLocation: true,
    VehicleReturnLocation: true,
    ProvidedServiceCategory: true,
    ProvidedServiceCategoryOther: true,
    InvoiceKind: true,
    OffSiteProvidedService: true, // // 16?. Παροχή Υπηρεσίων Εκτός Εγκατάστασης (OffSiteProvidedServiceType) (null = Χωρίς Μετακίνηση, 1 = Μετακίνηση σε συνεργαζόμενη οντότητα, 2 = Μετακίνηση σε εγκατάσταση εντός της ίδιας οντοτήτας)
    ExitDateTime: true,
    EntityVatNumber: true,
    CooperatingVatNumber: true, // 17?. Α.Φ.Μ Συνεργαζόμενης Οντοτητας (για το OffSiteProvidedServiceType = 2)
    OtherBranchAADE: true, // 18?. Άλλος Αρ. Εγκατάστασης εντός της ίδιας οντότητας (αλλο Branch) (για το OffSiteProvidedServiceType = 3)
    InvoiceCounterparty: true,
    InvoiceCounterpartyCountry: true,
    BranchId: true,
    BranchOtherId: true,
    Branch: BranchTypeQuery.GQLQuery(),
    BranchOther: BranchTypeQuery.GQLQuery(),
    Responses: DCLResponseTypeQuery.GQLQuery(),
    Invoices: InvoiceTypeQuery.GQLQuery({
        Response: ProviderResponseTypeQuery.GQLQuery(),
        Responses: ProviderResponseTypeQuery.GQLQuery()
    })

    // 1. Παρεχόμενη Υπηρεσία (DropDown) // Απαξ, Επαναλαμβανόμενη, Διαρκείς.
    // 2?. Εγκατάσταση (Υποκατάστημα)
    // 3. Αριθμός Κυκλοφορίας Οχήματος - Αριθμός Κυκλοφορίας Αλλοδαπής
    // 4. Ημερομηνία Εισόδου Οχήματος -  Ώρα Εισόδου Οχήματος
    // 5?. Εργοστάσιο Οχήματος - Κατηγορία Οχήματος
    // 6. Παρεχομενη Υπηρεσία (ProvidedCategoryServiceType)
    // 7?. Ημερομηνία ΕΞόδου Οχήματος - Ώρα Εξόδου Οχήματος
    // 8?. Συσχέτιση με άλλη Δήλωση Ψηφιακού Πελατολογίου?
    // 9?. Συσχετιζόμενος Α/Α Ψηφιακού Πελατολογίου
    // 10?. Μοναδικός Αριθμός Ψηφιακού Πελατολογίου (μας τον επιστρέφει η Α.Α.Δ.Ε)
    // 11?. Ειδός Παραστατικού (1 = ΑΛΠ/ΑΠΥ, 2 = ΤΙΜΟΛΟΓΙΟ, 3 = ΑΛΠ/ΑΠΥ-ΦΗΜ)
    // 12?. Α.Φ.Μ Αντισυμβαλόμενου (Εμφανίζεται αν επιλεγεί ΤΙΜΟΛΟΓΙΟ)
    // 13?. Συμφωνηθέν Ποσό (amount)
    // 14?. Παρατηρήσεις (comments)
    // 15. Οριστικοποιήμενη Εγγραφή - Κατάσταση (Η οριστικοποίηση θα γίνει με την έξοδο του οχήματος)
    // 16?. Παροχή Υπηρεσίων Εκτός Εγκατάστασης (OffSiteProvidedServiceType) (null = Χωρίς Μετακίνηση, 1 = Μετακίνηση σε συνεργαζόμενη οντότητα, 2 = Μετακίνηση σε εγκατάσταση εντός της ίδιας οντοτήτας)
    // 17?. Α.Φ.Μ Συνεργαζόμενης Οντοτητας (για το OffSiteProvidedServiceType = 2)
    // 18?. Άλλος Αρ. Εγκατάστασης εντός της ίδιας οντότητας (αλλο Branch) (για το OffSiteProvidedServiceType = 3)
    //
    // 19?. Παραστατικό - Μ.Α.Ρ.Κ (με την καταχώρηση του ΜΑΡΚ να κάνει Query Στην ΑΑΔΕ να φέρει τα υπόλοιπα στοιχεία)
    // Παραστατικό - Α/Α Παραστατικού
    // Παραστατικό - Σειρά Παραστατικού
    // Παραστατικό - Ημερομηνία Έκδοσης (μόνο Ημέρα, όχι ώρα)
    // Παραστατικό - Συνολική Αξία
    // Παραστατικό - Τρόπος Πληρωμής
} as DigitalClientCardTypeQuery;
@Component({
    selector: 'zion-dcl-card',
    imports: [
        FormsModule,
        ReactiveFormsModule,
        SelectModule,
        InputTextModule,
        DatePickerModule,
        TextareaModule,
        InputNumberModule,
        ServiceRecurringComponent,
        ZBranchSelectComponent,
        ZCarRegistrationNumberComponent,
        ZFloatLabelNotesComponent,
        ButtonModule,
        ZDclOffSiteProvidedServiceSelectorComponent,
        ToastModule,
        InvoiceCardCustomerComponent,
        ZCustomerSelectComponent
    ],
    templateUrl: './dcl-card.component.html',
    styleUrl: './dcl-card.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DclCardComponent implements OnInit {
    @HostBinding('class') class: string = 'flex flex-auto flex-col grow';
    dialogRef = inject(DynamicDialogRef);
    dialogService = inject(DialogService);
    store = inject(Store);
    cd = inject(ChangeDetectorRef);
    loaderService = inject(LoaderService);
    messageService = inject(ZionMessagesService);
    dclCardService = inject(DclCardService);

    postDCLsToAADESchema = inject(PostDCLsToAADESchema);

    /**
     * Config & Parameters που έρχονται από την dcl-cards.component.ts κατά το dialogService.open(DCLCardComponent) {...}
     */
    dclCardsDialogConfig: DynamicDialogConfig<DCLCardOptions> = inject(
        DynamicDialogConfig<DCLCardOptions>
    );
    dclFormGroup?: DigitalClientCardTypeFormGroup; //= new DigitalClientCardTypeFormGroup();
    dclCard = signal<DigitalClientCardType | undefined>(undefined);
    invoicesIssuedCount = signal<number | undefined>(undefined);
    nonIssueInvoice = signal<boolean | undefined>(undefined);
    selectedCustomer = signal<CustomerType | undefined>(undefined);
    destroySubject = new Subject<boolean>();

    branches = signal<BranchType[] | undefined>(undefined);

    constructor() {
        const options = this.dclCardsDialogConfig.data as DCLCardOptions;
        options.onRefresh = (options: DCLCardOptions) => {
            // alert('on Refrech DCL Card');
            this.fetchDataById(options.dclId).subscribe(() => {
                this.cd.detectChanges();
            });
        };
    }
    ngOnInit() {
        const options = this.dclCardsDialogConfig.data as DCLCardOptions;

        this.fetchDataById(options.dclId).subscribe();

        // const dclCard = {
        //     ...(options.digitalClientCardType ?? {
        //         ClientServiceType: 3, // 3: Garage
        //         ServiceRecurring: 1,
        //         CreationDateTime: undefined
        //     })
        // };

        // // Force this ServiceType
        // // TODO: Retrieve the ServiceType From branch
        // dclCard.ClientServiceType = 3;

        // this.nonIssueInvoice.set(
        //     dclCard?.Invoices?.map(
        //         (invoice) =>
        //             invoice.Response?.InvoiceMark != undefined &&
        //             (invoice.Response?.StatusCode?.toLocaleLowerCase() ==
        //                 'success' ||
        //                 invoice.Response?.StatusCode?.toLocaleLowerCase() ==
        //                     'offline')
        //     ).length == 0
        // );

        // dclCard.NonIssueInvoice = this.nonIssueInvoice();

        // this.dclCard.set(dclCard);

        // // Να βρούμε ποιο Response έχει (αν υπάρχει) το NewClientDclID.
        // // Μπορεί να υπάρχουν πολλά Responses, αλλά μονο ένα πρέπει να έχει το NewClientDclID!!!
        // // Μπορεί να έχουμε πολλα γιατί γίνονται πολλές κινήσεις πάνω σε μια εγγραφή όπως εισοδος (με κάποιες αποτυχίες ίσως), correlation (με κάποιες αποτυχίες ίσως), έξοδος (με κάποιες αποτυχίες ίσως)

        // // const newClientDclIDIndex = this.dclCard()?.Responses?.findIndex(
        // //     (response) => response.NewClientDclID != undefined
        // // );
        // // this.NewClientDclIDIndex.set(
        // //     newClientDclIDIndex != -1 ? newClientDclIDIndex : undefined
        // // );
        // //this.dclCard()?.DCLNewId

        // // this.dclCard()?.ReasonNonIssueType
        // // this.dclCard()?.OffSiteProvidedService
        // // this.dclCard()?.ProvidedServiceCategory
        // this.dclFormGroup = new DigitalClientCardTypeFormGroup(
        //     undefined,
        //     digitalClientCardFormGroupSelector
        // );

        // this.dclFormGroup?.valueChanges
        //     ?.pipe(takeUntil(this.destroySubject))
        //     .subscribe((formValue) => {
        //         console.debug(formValue);

        //         // invoiceKind is allowed only when ProvidedCategoryServiceType is 1,2 or 3  (code:; 205)
        //         this.dclFormGroup?.controls?.InvoiceKind?.setValue(undefined, {
        //             emitEvent: false
        //         });

        //         this.dclFormGroup?.controls?.NonIssueInvoice?.setValue(
        //             undefined,
        //             { emitEvent: false }
        //         );
        //         this.dclFormGroup?.controls?.ReasonNonIssueType?.setValue(
        //             undefined,
        //             { emitEvent: false }
        //         );
        //         switch (formValue.ProvidedServiceCategory) {
        //             // 1 = Εργασία με χρήση ανταλλακτικών (Συνεργεία)
        //             // 2 = Εργασία με χρήση ανταλλακτικών πελάτη (Συνεργεία)
        //             // 3 = Εργασία χωρίς χρήση ανταλλακτικών (Συνεργεία)
        //             case 1:
        //             case 2:
        //             case 3:
        //                 // this.dclFormGroup?.controls?.InvoiceKind?.setValue(
        //                 //     undefined,
        //                 //     { emitEvent: false }
        //                 // );
        //                 break;
        //             case 4: //Δωρεαν Υπηρεσία
        //             case 6: //Αποζημίωση Παροχής Εγγύησης
        //             case 9: // Ιδιόχρηση
        //                 // 1 = Δωρεάν Υπηρεσία (Ενοικίαση,Πάρκινγκ/ Πλυντήρια,Συνεργεία)
        //                 // 2 = Ιδιόχρηση (Ενοικίαση,Πάρκινγκ/ Πλυντήρια,Συνεργεία)
        //                 // 3 = Αποζημίωση Παροχής Εγγύησης (Συνεργεία)
        //                 this.dclFormGroup?.controls?.NonIssueInvoice?.setValue(
        //                     true,
        //                     { emitEvent: false }
        //                 );
        //                 switch (formValue.ProvidedServiceCategory) {
        //                     case 4:
        //                         this.dclFormGroup?.controls?.ReasonNonIssueType?.setValue(
        //                             1,
        //                             { emitEvent: false }
        //                         );
        //                         break;
        //                     case 6:
        //                         this.dclFormGroup?.controls?.ReasonNonIssueType?.setValue(
        //                             3,
        //                             { emitEvent: false }
        //                         );
        //                         break;
        //                     case 9:
        //                         this.dclFormGroup?.controls?.ReasonNonIssueType?.setValue(
        //                             2,
        //                             { emitEvent: false }
        //                         );
        //                         break;
        //                 }

        //                 break;
        //         }
        //     });

        // this.dclFormGroup.patchValueFromEntity(
        //     this.dclCard(),
        //     digitalClientCardFormGroupSelector
        // );

        // // this.dclCard()?.Invoices?.filter(filter => filter.Response?.StatusCode?.toLocaleLowerCase() == 'success' || filter.Response?.StatusCode?.toLocaleLowerCase() == 'offline').length;
        // this.invoicesIssuedCount.set(
        //     this.dclCard()?.Invoices?.filter(
        //         (filter) =>
        //             filter.Response?.StatusCode?.toLocaleLowerCase() ==
        //                 'success' ||
        //             filter.Response?.StatusCode?.toLocaleLowerCase() ==
        //                 'offline' ||
        //             filter.Response?.InvoiceMark == 0 // Αν για κάποιο λόγο έγινε προσπάθεια πληρωμής με κάρτα και απέτυχε δεν πρέπει να μπορεί να αλλάξει Τύπο παραστατικού.
        //     ).length
        // );

        // // this.dclFormGroup.controls.Responses?.controls?.[0]?.controls?.NewClientDclID?.disable();
        // this.dclFormGroup.controls.NonIssueInvoice?.disable();

        // options.digitalClientCardTypeFormGroup = this.dclFormGroup;
        // options.onFormGroupSet?.(this.dclFormGroup);

        // console.debug(this.dclCard(), this.dclFormGroup);
    }

    fetchDataById(_id: ObjectId | undefined) {
        const fetchQueryParameters = QueryFilter.FetchQueryParamsForEntityId(
            _id ?? '000000000000000000000000'
        );

        return this.store
            .dispatch([
                new DigitalClientCardGraphQLSchemaActions.Fetch(
                    this.dclCardService.digitalClientCardGQLQueryForEdit,
                    {
                        ...fetchQueryParameters //...QueryFilterGroup.JoinWithAndOperator(groups), //...QueryFilter.FetchQueryParamsFromAGGridParams(params),
                    },
                    '',
                    ''
                )
            ])
            .pipe(
                finalize(() => {}),
                concatMap(() => {
                    const digitalClientCardType:
                        | DigitalClientCardType
                        | undefined = this.store.selectSnapshot(
                        DigitalClientCardGraphQLSchemaSelectors.FetchSelector(
                            '',
                            ''
                        )
                    )?.data.Fetch?.[0];

                    const options = this.dclCardsDialogConfig
                        .data as DCLCardOptions;

                    debugger;
                    const dclCard = {
                        ...(digitalClientCardType ??
                            options.digitalClientCardType ?? {
                                ClientServiceType: 3, // 3: Garage
                                ServiceRecurring: 1,
                                CreationDateTime: undefined
                            })
                    };

                    dclCard.Customer =
                        dclCard.Customer ??
                        options.digitalClientCardType?.Customer;

                    dclCard.CustomerId =
                        dclCard.CustomerId ??
                        options.digitalClientCardType?.CustomerId;

                    dclCard.SubjectId =
                        dclCard.SubjectId ??
                        options.digitalClientCardType?.SubjectId;

                    dclCard.CalendarId =
                        dclCard.CalendarId ??
                        options.digitalClientCardType?.CalendarId;

                    // Force this ServiceType
                    // TODO: Retrieve the ServiceType From branch
                    dclCard.ClientServiceType = 3;

                    this.nonIssueInvoice.set(
                        dclCard?.Invoices?.map(
                            (invoice) =>
                                invoice.Response?.InvoiceMark != undefined &&
                                (invoice.Response?.StatusCode?.toLocaleLowerCase() ==
                                    'success' ||
                                    invoice.Response?.StatusCode?.toLocaleLowerCase() ==
                                        'offline')
                        ).length == 0
                    );

                    dclCard.NonIssueInvoice = this.nonIssueInvoice();

                    this.selectedCustomer.set(dclCard.Customer);

                    this.dclCard.set(dclCard);

                    // Να βρούμε ποιο Response έχει (αν υπάρχει) το NewClientDclID.
                    // Μπορεί να υπάρχουν πολλά Responses, αλλά μονο ένα πρέπει να έχει το NewClientDclID!!!
                    // Μπορεί να έχουμε πολλα γιατί γίνονται πολλές κινήσεις πάνω σε μια εγγραφή όπως εισοδος (με κάποιες αποτυχίες ίσως), correlation (με κάποιες αποτυχίες ίσως), έξοδος (με κάποιες αποτυχίες ίσως)

                    // const newClientDclIDIndex = this.dclCard()?.Responses?.findIndex(
                    //     (response) => response.NewClientDclID != undefined
                    // );
                    // this.NewClientDclIDIndex.set(
                    //     newClientDclIDIndex != -1 ? newClientDclIDIndex : undefined
                    // );
                    //this.dclCard()?.DCLNewId

                    // this.dclCard()?.ReasonNonIssueType
                    // this.dclCard()?.OffSiteProvidedService
                    // this.dclCard()?.ProvidedServiceCategory

                    this.destroySubject.next(true);

                    this.dclFormGroup = new DigitalClientCardTypeFormGroup(
                        undefined,
                        digitalClientCardFormGroupSelector
                    );

                    this.dclFormGroup?.valueChanges
                        ?.pipe(takeUntil(this.destroySubject))
                        .subscribe((formValue) => {
                            console.debug(
                                'dclFormGroup -> ValueChanges',
                                formValue,
                                formValue.CompletionDateTime
                            );

                            // invoiceKind is allowed only when ProvidedCategoryServiceType is 1,2 or 3  (code:; 205)
                            this.dclFormGroup?.controls?.InvoiceKind?.setValue(
                                undefined,
                                {
                                    emitEvent: false
                                }
                            );

                            this.dclFormGroup?.controls?.NonIssueInvoice?.setValue(
                                undefined,
                                { emitEvent: false }
                            );
                            this.dclFormGroup?.controls?.ReasonNonIssueType?.setValue(
                                undefined,
                                { emitEvent: false }
                            );
                            switch (formValue.ProvidedServiceCategory) {
                                // 1 = Εργασία με χρήση ανταλλακτικών (Συνεργεία)
                                // 2 = Εργασία με χρήση ανταλλακτικών πελάτη (Συνεργεία)
                                // 3 = Εργασία χωρίς χρήση ανταλλακτικών (Συνεργεία)
                                case 1:
                                case 2:
                                case 3:
                                    // this.dclFormGroup?.controls?.InvoiceKind?.setValue(
                                    //     undefined,
                                    //     { emitEvent: false }
                                    // );
                                    break;
                                case 4: //Δωρεαν Υπηρεσία
                                case 6: //Αποζημίωση Παροχής Εγγύησης
                                case 9: // Ιδιόχρηση
                                    // 1 = Δωρεάν Υπηρεσία (Ενοικίαση,Πάρκινγκ/ Πλυντήρια,Συνεργεία)
                                    // 2 = Ιδιόχρηση (Ενοικίαση,Πάρκινγκ/ Πλυντήρια,Συνεργεία)
                                    // 3 = Αποζημίωση Παροχής Εγγύησης (Συνεργεία)
                                    this.dclFormGroup?.controls?.NonIssueInvoice?.setValue(
                                        true,
                                        { emitEvent: false }
                                    );
                                    switch (formValue.ProvidedServiceCategory) {
                                        case 4:
                                            this.dclFormGroup?.controls?.ReasonNonIssueType?.setValue(
                                                1,
                                                { emitEvent: false }
                                            );
                                            break;
                                        case 6:
                                            this.dclFormGroup?.controls?.ReasonNonIssueType?.setValue(
                                                3,
                                                { emitEvent: false }
                                            );
                                            break;
                                        case 9:
                                            this.dclFormGroup?.controls?.ReasonNonIssueType?.setValue(
                                                2,
                                                { emitEvent: false }
                                            );
                                            break;
                                    }

                                    break;
                            }
                        });

                    this.dclFormGroup.patchValueFromEntity(
                        this.dclCard(),
                        digitalClientCardFormGroupSelector,
                        { emitEvent: false }
                    );

                    // this.dclCard()?.Invoices?.filter(filter => filter.Response?.StatusCode?.toLocaleLowerCase() == 'success' || filter.Response?.StatusCode?.toLocaleLowerCase() == 'offline').length;
                    this.invoicesIssuedCount.set(
                        this.dclCard()?.Invoices?.filter(
                            (filter) =>
                                filter.Response?.StatusCode?.toLocaleLowerCase() ==
                                    'success' ||
                                filter.Response?.StatusCode?.toLocaleLowerCase() ==
                                    'offline' ||
                                filter.Response?.InvoiceMark == 0 // Αν για κάποιο λόγο έγινε προσπάθεια πληρωμής με κάρτα και απέτυχε δεν πρέπει να μπορεί να αλλάξει Τύπο παραστατικού.
                        ).length
                    );

                    // this.dclFormGroup.controls.Responses?.controls?.[0]?.controls?.NewClientDclID?.disable();
                    this.dclFormGroup.controls.NonIssueInvoice?.disable();
                    if (
                        this.dclFormGroup?.controls?.DCLNewId?.value !=
                        undefined
                    )
                        this.dclFormGroup.controls.CustomerId?.disable();

                    options.digitalClientCardTypeFormGroup = this.dclFormGroup;
                    options.onFormGroupSet?.(this.dclFormGroup);

                    console.debug(this.dclCard(), this.dclFormGroup);
                    this.cd.detectChanges();
                    return of(undefined);
                })
            );
        // .pipe(
        //     map(
        //         () =>
        //             this.store.selectSnapshot(
        //                 DigitalClientCardGraphQLSchemaSelectors.FetchSelector(
        //                     '',
        //                     ''
        //                 )
        //             )?.data?.Fetch ?? []
        //     )
        // )
        // .subscribe(() => {

        //     const dclCards =
        //         this.store.selectSnapshot(
        //             DigitalClientCardGraphQLSchemaSelectors.FetchSelector(
        //                 '',
        //                 ''
        //             )
        //         )?.data?.Fetch ?? [];
        //     this.dclCards.set(dclCards);
        //     dclCards[0].Invoices;
        // });
    }

    // Συσχέτηση παραστατικού με εγγραφή ψηφιακού πελατολογίου και  Ολοκλήρωση Εγραφής Ψηφιακού Πελατολογίου (κουμπάκι 'Έξοδος Οχήματος')
    /**
     * @returns
     */
    // completeDCL_Obs() {
    //     const options = this.dclCardsDialogConfig.data as DCLCardOptions;

    //     const digitalClientCard =
    //         options.digitalClientCardTypeFormGroup?.getRawValue() as
    //             | DigitalClientCardInputType
    //             | undefined;
    //     if (
    //         digitalClientCard == undefined ||
    //         digitalClientCard._id == undefined
    //     )
    //         return;

    //     this.loaderService.showAwaitDataSaveLoader(
    //         'Οριστοκοποίηση Εγγραφής Ψηφιακού Πελατολογίου'
    //     );
    //     // Ενημέρωσε τη βάση με ότι αλλαγές έχουν γίνει στη φόρμα.
    //     this.store
    //         .dispatch(
    //             new DigitalClientCardGraphQLSchemaActions.Upsert(
    //                 digitalClientCard,
    //                 undefined,
    //                 this.dclCardService.digitalClientCardGQLQueryForEdit
    //             )
    //         )
    //         .pipe(
    //             concatMap(() => {
    //                 debugger;
    //                 const dclCard = this.store.selectSnapshot(
    //                     DigitalClientCardGraphQLSchemaSelectors.UpsertSelector(
    //                         '',
    //                         ''
    //                     )
    //                 )?.data?.Upsert;

    //                 // Φέρε το πρώτο παραστατικό που έχει έρθει επιτυχώς (InvoiceMark > 0). θα έχουμε πάντα ένα παραστατικό. Δεν υποστήρίζουμε 2 παραστατικά σε κάθε εγγραφή.
    //                 // (Όταν θα βάλουμε τη δυνατότητα να δένει 2 παραστατικά θα τα δένει από αλλού.)
    //                 const invoiceWithMark = dclCard?.Invoices?.find(
    //                     (invoice) => (invoice.Response?.InvoiceMark ?? 0) > 0
    //                 );

    //                 // Αν απαιτείται παραστατικό τότε πρέπει να δούμε αν βρήκαμε κάποιο με _id
    //                 switch (digitalClientCard.ProvidedServiceCategory) {
    //                     case 1:
    //                     case 2:
    //                     case 3:
    //                         // Αν δεν υπάρχουν Παραστατικά τότε ανοίγουμε τη φόρμα του νέου παρστατικού.
    //                         if ((dclCard?.Invoices ?? []).length == 0) {
    //                             // ΠΡΟΣΟΧΗ: Όταν ανοίξει η φόρμα του νεόυ παραστατικού και ο χρήστης πατήσει έκδοση/διαβίβαση παραστατικού δίχως να έχει επιλέξει τρόπο πληρωμής
    //                             // το σύστημα πρέπει να του ζητήσει τρόπο πληρωμής και μετά να συνεχίσει στην έκδοση/διαβίβαση.
    //                             this.newInvoice(digitalClientCard, '11.2');

    //                             return of({
    //                                 data: {
    //                                     UpdateDigitalClientCard: undefined
    //                                 }
    //                             });
    //                         }

    //                         // Εδώ έχουμε δει ότι έχουμε τουλάχιστον ένα παραστατικό.
    //                         // Για να ολοκληρωθεί σωστά μια εγγραφή ψηφιακού πελατολογίου τύπου 1 ή 2 ή 3 θα πρέπει να υπάρχει παραστατικό με ΜΑΡΚ.
    //                         // Το A.P.I του ψηφιακού πελατολογίου δεν κάνει έλεγχο αν ο χρήστης έχει καταχωρήσει το MARK, παρά μόνο αν έχει καταχωρήσει τον τύπο του παραστατικού
    //                         // που ΘΑ εκδόσει. Το παραστατικό μπορεί να εκδοθεί και σε 2ο χρόνο!!!!
    //                         if (invoiceWithMark == undefined) {
    //                             digitalClientCard.EntryCompletion = undefined;

    //                             // this.messageService.add({
    //                             //     summary: 'Μη έκδοση Φορολογικού Στοιχείου',
    //                             //     detail: "Δεν έχετε εκδώσει το απαραίτητο Φορολογικό Στοιχείο. Η 'Κατηγορία Παρεχόμενων Υπηρεσιών' που έχετε επιλέξει απαιτεί να εκδώσετε και να διαβιβάσετε στην Α.Α.Δ.Ε το ανάλογο παραστατικό.",
    //                             //     severity: 'error',
    //                             //     key: 'br'
    //                             // } as ToastMessageOptions);

    //                             // Άνοιξε τη φόρμα του 'ΠΡΩΤΟΥ' παραστατικού για να ολοκληρωθεί το παραστατικό.
    //                             this.editInvoice(digitalClientCard, 0);

    //                             return of({
    //                                 data: {
    //                                     UpdateDigitalClientCard: undefined
    //                                 }
    //                             });
    //                         }
    //                         break;
    //                 }

    //                 // Αν είμαστε σε αυτό το σημείο τότε είναι ολα εντάξει για να προχωρήσουμε στην ολοκλήρωση της εγγραφής του ψηφιακού πελατολογίου.
    //                 //
    //                 // ζητάμε από τον Server μας να καλέσει τo DCL/UpdateCLient (DCL_UpdateCLientAsync) endPoint της Α.Α.Δ.Ε με
    //                 // το πεδίο EntryCompletion = digitalClientCard.EntryCompletion.
    //                 digitalClientCard.EntryCompletion = true;

    //                 return this.store
    //                     .dispatch(
    //                         // Ενημέρωσε πάλι την εγγραφή με το πεδίο EntryCompletion
    //                         new DigitalClientCardGraphQLSchemaActions.Upsert(
    //                             digitalClientCard,
    //                             undefined,
    //                             this.dclCardService.digitalClientCardGQLQueryForEdit
    //                         )
    //                     )
    //                     .pipe(
    //                         concatMap(() => {
    //                             let updatedDigitalClientCard =
    //                                 this.store.selectSnapshot(
    //                                     DigitalClientCardGraphQLSchemaSelectors.UpsertSelector(
    //                                         '',
    //                                         ''
    //                                     )
    //                                 )?.data.Upsert ?? digitalClientCard;

    //                             console.debug(
    //                                 'Correlate Digital Client Card: ',
    //                                 updatedDigitalClientCard
    //                             );

    //                             // Δες αν έχει ζητηθεί η μη έκδοση παραστατικού για να μη κάνει καμία συσχέτηση.
    //                             // Προσοχή: Θεωρητικά, το επιτρέπει η Α.Α.Δ.Ε, να ορίσει ο χρήστης ότι δεν θέλει να εκδώσει παραστατικό!!!
    //                             const nonIssueInvoice =
    //                                 updatedDigitalClientCard.NonIssueInvoice;

    //                             return (
    //                                 nonIssueInvoice != true &&
    //                                 updatedDigitalClientCard.EntryCompletion ==
    //                                     true // Αν δεν είναι απαραίτητο το παραστατικό δεν συσχετίζεις παραστατικό.
    //                                     ? // Εδώ γίνεται η συσχέτηση της εγγραφής του ψηφιακού πελατολογίου με ένα παραστατικό.
    //                                       // Αν δεν υπάρχει παραστατικό τότε δεν μπορεί να γίνει η συχέτηση.
    //                                       this.postDCLsToAADESchema.CorrelateDigitalClientCard(
    //                                           updatedDigitalClientCard,
    //                                           invoiceWithMark,
    //                                           this.dclCardService
    //                                               .digitalClientCardGQLQueryForEdit
    //                                       )
    //                                     : of(undefined)
    //                             ).pipe(
    //                                 concatMap(
    //                                     (
    //                                         correlateDigitalClientCardResponse
    //                                     ) => {
    //                                         // 2025/06/2025 Saridakis Antonis
    //                                         // Mε αυτή τη κλήση γίνεται η ολοκλήρωση της εγγραφής του ψηφιακού πελατολογίου.
    //                                         //
    //                                         // Εδώ ο Server θα καλέσει τo DCL/UpdateCLient (DCL_UpdateCLientAsync) endPoint της Α.Α.Δ.Ε με
    //                                         // το πεδίο EntryCompletion = digitalClientCard.EntryCompletion.
    //                                         //
    //                                         // Αυτό σημαίνει ότι αν το πεδίο αυτό δεν πάρει την τιμη 'true' δεν θα γίνει ποτέ η ολoκλήρωση της εγγραφής
    //                                         // η οποία απλά θα γίνεται update.
    //                                         return this.postDCLsToAADESchema.UpdateDigitalClientCard(
    //                                             updatedDigitalClientCard,
    //                                             this.dclCardService
    //                                                 .digitalClientCardGQLQueryForEdit
    //                                         );
    //                                     }
    //                                 )
    //                             );
    //                         })
    //                     );
    //             }),
    //             finalize(() => this.loaderService.dismissAwaitLoader())
    //         )
    //         .subscribe((digitalCardType) => {
    //             const lastResponse =
    //                 digitalCardType?.data?.UpdateDigitalClientCard?.Responses?.sort(
    //                     (a, b) => {
    //                         const sort: number = 2; // 1 Ascending, 2 Descending
    //                         if (a.ResponseDate == undefined)
    //                             return sort == 1 ? -1 : 1; // Ascending

    //                         if (b.ResponseDate == undefined)
    //                             return sort == 1 ? 1 : -1; // Descending

    //                         if (a.ResponseDate < b.ResponseDate)
    //                             return sort == 1 ? -1 : 1;
    //                         if (a.ResponseDate > b.ResponseDate)
    //                             return sort == 1 ? 1 : -1;

    //                         return 0;
    //                     }
    //                 )?.[0];

    //             if (lastResponse?.Errors?.Error?.[0]?.Message != undefined) {
    //                 this.messageService.add({
    //                     summary: 'Αποτυχία ενημέρωσης Α.Α.Δ.Ε',
    //                     detail: lastResponse?.Errors?.Error?.[0]?.Message ?? '',
    //                     severity: 'error',
    //                     key: 'br'
    //                 } as ToastMessageOptions);
    //             } else {
    //                 if (digitalCardType?.data?.UpdateDigitalClientCard) {
    //                     this.messageService.add({
    //                         summary: 'Έξοδος Οχήματος',
    //                         detail: 'Η εγγραφή οριστικοποιήθηκε επιτυχώς',
    //                         severity: 'success',
    //                         key: 'br'
    //                     } as ToastMessageOptions);
    //                     options.onDCLCardSave(options);
    //                 }
    //             }
    //         });

    //     // // ζητάμε από τον Server μας να καλέσει τo DCL/UpdateCLient (DCL_UpdateCLientAsync) endPoint της Α.Α.Δ.Ε με
    //     // // // το πεδίο EntryCompletion = digitalClientCard.EntryCompletion.
    //     // digitalClientCard.EntryCompletion = true;

    //     // debugger;
    //     // switch (digitalClientCard.ProvidedServiceCategory) {
    //     //     case 1:
    //     //     case 2:
    //     //     case 3:
    //     //         //case 5: //TODO: Tcheck this Category !!!!!
    //     //         // this.dclFormGroup?.controls?.InvoiceKind?.setValue(
    //     //         //     undefined,
    //     //         //     { emitEvent: false }
    //     //         // );

    //     //         // Για να ολοκληρωθεί σωστά μια εγγραφή ψηφιακού πελατολογίου τύπου 1 ή 2 ή 3 θα πρέπει να υπάρχει παραστατικό με ΜΑΡΚ.
    //     //         // Το A.P.I του ψηφιακού πελατολογίου δεν κάνει έλεγχο αν ο χρήστης έχει καταχωρήσει το MARK, παρά μόνο αν έχει καταχωρήσει τον τύπο του παραστατικού
    //     //         // που ΘΑ εκδόσει. Το παραστατικό μπορεί να εκδοθεί και σε 2ο χρόνο!!!!
    //     //         if (digitalClientCard.InvoiceId == undefined) {
    //     //             digitalClientCard.EntryCompletion = undefined;

    //     //             this.messageService.add({
    //     //                 summary: 'Δεν βρέθηκε Φορολογικό Στοιχείο',
    //     //                 detail: "Δεν έχετε καταχωρήσει το απαραίτητο Φορολογικό Στοιχείο. Η 'Κατηγορία Παρεχόμενων Υπηρεσιών' που έχετε επιλέξει απαιτεί να εκδώσετε και να διαβιβάσετε στην Α.Α.Δ.Ε το ανάλογο παραστατικό.",
    //     //                 severity: 'error',
    //     //                 key: 'br'
    //     //             } as ToastMessageOptions);

    //     //             return;
    //     //         }
    //     //         break;
    //     // }

    //     // this.loaderService.showAwaitDataSaveLoader();

    //     // this.store
    //     //     .dispatch(
    //     //         new DigitalClientCardGraphQLSchemaActions.Upsert(
    //     //             digitalClientCard,
    //     //             undefined,
    //     //             digitalClientCardGQLQueryForEdit
    //     //         )
    //     //     )
    //     //     .pipe(
    //     //         concatMap(() => {
    //     //             let updatedDigitalClientCard =
    //     //                 this.store.selectSnapshot(
    //     //                     DigitalClientCardGraphQLSchemaSelectors.UpsertSelector(
    //     //                         '',
    //     //                         ''
    //     //                     )
    //     //                 )?.data.Upsert ?? digitalClientCard;

    //     //             console.debug(
    //     //                 'Correlate Digital Client Card: ',
    //     //                 updatedDigitalClientCard
    //     //             );

    //     //             const nonIssueInvoice =
    //     //                 updatedDigitalClientCard.NonIssueInvoice;

    //     //             // // Αν δεν υπάρχει δεμένο παραστατικό δημιούργησε ένα καινούριο
    //     //             // if (updatedDigitalClientCard.InvoiceId == undefined) {
    //     //             //     this.newInvoice(digitalClientCard, '11.2');
    //     //             //     return of({
    //     //             //         data: {
    //     //             //             UpdateDigitalClientCard:
    //     //             //                 updatedDigitalClientCard
    //     //             //         }
    //     //             //     });
    //     //             // }

    //     //             return (
    //     //                 nonIssueInvoice != true // Αν δεν είναι απαραίτητο το παραστατικό δεν συσχετήζεις παραστατικό.
    //     //                     ? // Εδώ γίνεται η συσχέτηση της εγγραφής του ψηφιακού πελατολογίου με ένα παραστατικό.
    //     //                       // Αν δεν υπάρχει παραστατικό τότε δεν μπορεί να γίνει η συχέτηση.
    //     //                       this.postDCLsToAADESchema.CorrelateDigitalClientCard(
    //     //                           updatedDigitalClientCard,
    //     //                           digitalClientCardGQLQueryForEdit
    //     //                       )
    //     //                     : of(undefined)
    //     //             ).pipe(
    //     //                 concatMap((digitalClientCardResponse) => {
    //     //                     // 2025/06/2025 Saridakis Antonis
    //     //                     // Mε αυτή τη κλήση γίνεται η ολοκλήρωση της εγγραφής του ψηφιακού πελατολογίου.
    //     //                     //
    //     //                     // Εδώ ο Server θα καλέσει τo DCL/UpdateCLient (DCL_UpdateCLientAsync) endPoint της Α.Α.Δ.Ε με
    //     //                     // το πεδίο EntryCompletion = digitalClientCard.EntryCompletion.
    //     //                     //
    //     //                     // Αυτό σημαίνει ότι αν το πεδίο αυτό δεν πάρει την τιμη 'true' δεν θα γίνει ποτέ η ολoκλήρωση της εγγραφής
    //     //                     // η οποία απλά θα γίνεται update.
    //     //                     return this.postDCLsToAADESchema.UpdateDigitalClientCard(
    //     //                         updatedDigitalClientCard,
    //     //                         digitalClientCardGQLQueryForEdit
    //     //                     );
    //     //                 })
    //     //             );
    //     //         }),
    //     //         finalize(() => this.loaderService.dismissAwaitLoader())
    //     //     )
    //     //     // .pipe(finalize(() => this.loaderService.dismissAwaitLoader()))
    //     //     .subscribe((digitalCardType) => {
    //     //         const lastResponse =
    //     //             digitalCardType?.data?.UpdateDigitalClientCard?.Responses?.sort(
    //     //                 (a, b) => {
    //     //                     const sort: number = 2; // 1 Ascending, 2 Descending
    //     //                     if (a.ResponseDate == undefined)
    //     //                         return sort == 1 ? -1 : 1; // Ascending

    //     //                     if (b.ResponseDate == undefined)
    //     //                         return sort == 1 ? 1 : -1; // Descending

    //     //                     if (a.ResponseDate < b.ResponseDate)
    //     //                         return sort == 1 ? -1 : 1;
    //     //                     if (a.ResponseDate > b.ResponseDate)
    //     //                         return sort == 1 ? 1 : -1;

    //     //                     return 0;
    //     //                 }
    //     //             )?.[0];

    //     //         if (lastResponse?.Errors?.Error?.[0]?.Message != undefined) {
    //     //             this.messageService.add({
    //     //                 summary: 'Αποτυχία ενημέρωσης Α.Α.Δ.Ε',
    //     //                 detail: lastResponse?.Errors?.Error?.[0]?.Message ?? '',
    //     //                 severity: 'error',
    //     //                 key: 'br'
    //     //             } as ToastMessageOptions);
    //     //         } else {
    //     //             options.onSave(options);
    //     //         }
    //     //     });

    //     // this.postDCLsToAADESchema
    //     //     .CorrelateDigitalClientCard(
    //     //         digitalClientCard,
    //     //         DigitalClientCardTypeQuery.GQLQuery()
    //     //     )
    //     //     .pipe(finalize(() => this.loaderService.dismissAwaitLoader()))
    //     //     .subscribe(() => {
    //     //         options.onSave(options);
    //     //     });
    // }

    /**
     * Event on customer Selection
     * @param $event
     */
    onCustomerSelected($event: {
        customerType: CustomerType | undefined;
        rowIndex?: number;
    }) {
        this.selectedCustomer.set($event.customerType);

        // Clear the fields if selected customer is undefined
        this.dclFormGroup?.controls?.SubjectId?.setValue(
            $event.customerType?.Subjects?.[0]?.Subject?._id,
            { emitEvent: false }
        );

        // Δεν θέλουμε τις παυλες εδώ
        this.dclFormGroup?.controls?.Garage?.controls?.VehicleRegistrationNumber?.setValue(
            $event.customerType?.Subjects?.[0]?.Subject?.PlateNo,
            { emitEvent: false }
        );

        this.cd.detectChanges();
    }

    onRegistrationNumberSelected(registrationNumber: string | undefined) {
        //this.registrationNumberSelected.emit(registrationNumber);
        console.debug('onRegistrationNumberSelected: ', registrationNumber);
        this.fetchCustomerByPlateNo(registrationNumber);
    }

    fetchCustomerByPlateNo(plateNo: string | undefined) {
        const groupOfPlateNo =
            QueryFilterGroup.FieldIsEqualToString<EntitySubjectInfoType>(
                ['PlateNo'],
                plateNo
            );

        this.store
            .dispatch(
                new EntitySubjectInfoGraphQLSchemaActions.Fetch(
                    entitySubjectInfoTypeQuery,
                    {
                        GroupQuery: groupOfPlateNo
                    }
                )
            )
            .subscribe(() => {
                const subjects = this.store.selectSnapshot(
                    EntitySubjectInfoGraphQLSchemaSelectors.FetchSelector(
                        '',
                        ''
                    )
                )?.data.Fetch;

                this.selectedCustomer.set(
                    subjects?.[0]?.SubjectsToCustomers?.[0]?.Customer
                );

                this.cd.detectChanges();
            });
    }

    validateDCLCorrelation(dclCard?: DigitalClientCardType) {
        if (dclCard) {
            const lastInvoiceIndex = (dclCard.Invoices?.length ?? 0) - 1;

            const lastInvoiceResponse =
                dclCard.Invoices?.[lastInvoiceIndex]?.Response;
            const invoice = dclCard.Invoices?.[lastInvoiceIndex];

            const statusCode = invoice?.DCLCorrelationResponse?.StatusCode;
            switch (statusCode?.toLocaleLowerCase()) {
                case 'success':
                    this.messageService.add({
                        summary: 'Συσχέτιση Παραστατικού',
                        detail: 'Η Συσχέτιση του Παραστατικού με την Εγγραφή του Ψηφιακού Πελατολογίου ολοκληρώθηκε επιτυχώς',
                        severity: 'success',
                        key: 'br'
                    } as ToastMessageOptions);
                    break;
                default:
                    this.messageService.add({
                        summary: 'Αποτυχία Συσχέτισης Παραστατικού',
                        detail: invoice?.DCLCorrelationResponse?.Errors
                            ?.Error?.[0]?.Message,
                        severity: 'error',
                        key: 'br'
                    } as ToastMessageOptions);
                    break;
            }
        }
    }

    /**
     * Βρίσκει την τελυταία απάντηση από τις κλήσεις στην Α.Α.Δ.Ε για το ψηφιακό πελατολόγιο
     * και ενημερώνει τον χρήστη αν ολοκληρώθηκε επιτηχώς ή όχι η Έξοδος Οχήματος.
     * @param digitalCardType
     */
    validateDCLCompletion(
        digitalCardType?: DigitalClientCardType,
        options?: DCLCardOptions
    ) {
        const lastResponse = digitalCardType?.Responses?.sort((a, b) => {
            const sort: number = 2; // 1 Ascending, 2 Descending
            if (a.ResponseDate == undefined) return sort == 1 ? -1 : 1; // Ascending

            if (b.ResponseDate == undefined) return sort == 1 ? 1 : -1; // Descending

            if (a.ResponseDate < b.ResponseDate) return sort == 1 ? -1 : 1;
            if (a.ResponseDate > b.ResponseDate) return sort == 1 ? 1 : -1;

            return 0;
        })?.[0];

        if (lastResponse?.Errors?.Error?.[0]?.Message != undefined) {
            this.messageService.add({
                summary: 'Αποτυχία ενημέρωσης Α.Α.Δ.Ε',
                detail: lastResponse?.Errors?.Error?.[0]?.Message ?? '',
                severity: 'error',
                key: 'br'
            } as ToastMessageOptions);
        } else {
            if (digitalCardType) {
                this.messageService.add({
                    summary: 'Έξοδος Οχήματος',
                    detail: 'Η εγγραφή οριστικοποιήθηκε επιτυχώς',
                    severity: 'success',
                    key: 'br'
                } as ToastMessageOptions);
                debugger;
                options?.onDCLCardSave(options);
            }
        }
    }

    /**
     * Ενημέρωσε το Ψηφιακό Πελατολόγιο με τον τύπο του παραστατικού που θα εκδόσεις και εμφάνισε το Modal των παραστατικών.
     * @param invoiceType Ο τύπος του παραστατικού που θέλουμε. Αυτό επιλέγεται από το κουμπί στο HTML.
     */
    updateInvoiceKind(invoiceType: 'invoice' | 'receipt', source: 'dcl-modal') {
        this.dclFormGroup?.controls?.InvoiceKind?.setValue(
            invoiceType == 'invoice' ? 2 : 1,
            { emitEvent: false }
        );

        // this.dclFormGroup?.controls?.EntryCompletion?.setValue(true, {
        //     emitEvent: false
        // });

        // const digitalClientCard = this.dclFormGroup?.getRawValue() as
        //     | DigitalClientCardInputType
        //     | undefined;

        // this.loaderService.showAwaitLoader(
        //     'Ενημέρωση Ψηφιακού Πελατολογίου. Παρακαλώ Περιμένετε...'
        // );

        // this.store
        //     .dispatch(
        //         new DigitalClientCardGraphQLSchemaActions.Upsert(
        //             digitalClientCard,
        //             undefined,
        //             this.dclCardService.digitalClientCardGQLQueryForEdit
        //         )
        //     )
        //     .pipe(finalize(() => this.loaderService.dismissAwaitLoader()))
        //     .subscribe(() => {
        //         // Εδώ πρέπει να αποδφασίοσυμε
        //     });

        debugger;
        this.dclCardService
            .updateInvoiceKindOrCompleteDCL(
                invoiceType,
                this.dclCardsDialogConfig.data as DCLCardOptions,
                this.dclFormGroup,
                source
            )
            .subscribe((digitalClientCardType) => {
                debugger;
                // Εδώ έχει γυρίσει με ενημερώμένο το invoiceKind του DigitalClientCard
                this.fetchDataById(digitalClientCardType?._id);
            });

        // this.dclCardService
        //     .completeDCL(
        //         invoiceType,
        //         this.dclFormGroup,
        //         this.dialogConfig as DCLCardOptions
        //     )
        //     ?.subscribe();
    }

    bindCDLWithInvoices(invoiveType: 'invoice' | 'receipt') {
        this.dclCardService.bindCDLWithInvoices(
            invoiveType,
            this.dclCardsDialogConfig.data as DCLCardOptions
        );
    }

    /**
     * Έξοδος Οχήματος. Εϊναι ο 3ος χρόνος στις προδιαγραφές (https://www.aade.gr/sites/default/files/2025-06/epixirisiaki_anal_psif_pelat_v.1.1_0.pdf)
     * 1. Ενημερώνουμε τη βάση με τις όποιες αλλαγές.
     * 2. Να δούμε αν υπάρχει καταχωρημένο παραστατικό (ή παραστατικά) για την εγγραφή του ψηφιακού πελατολογίου που μόλις καταχωρήσαμε.
     * 3. Αν Δεν υπάρχει Παραστατικό δεμένο στην εγγραφή ψηφιακού πελατολογίου τότε πρέπει να ζητήσουμε από τον χρήστη να καταχωρήσει ένα.
     * 4. Αν Υπάρχει παραστατικό ΧΩΡΙ΅ ΜΑΡΚ τότε ανοίγουμε το παραστατικό για Πληρωμή και Έκδοση.
     * 5. Αν Υπάρχει παραστατικό με ΜΑΡΚ τότε κάνουμε Correlate την εγγραφή.
     * @returns nothing
     */
    completeDCL2() {
        this.dclCardService.completeDCL2(
            this.dclCardsDialogConfig.data as DCLCardOptions
        );
    }

    /**
     * @deprecated
     * @returns
     */
    completeDCL223333() {
        const options = this.dclCardsDialogConfig.data as DCLCardOptions;

        const digitalClientCard =
            options.digitalClientCardTypeFormGroup?.getRawValue() as
                | DigitalClientCardInputType
                | undefined;
        if (
            digitalClientCard == undefined ||
            digitalClientCard._id == undefined
        )
            return;

        this.loaderService.showAwaitDataSaveLoader(
            'Οριστοκοποίηση Εγγραφής Ψηφιακού Πελατολογίου'
        );
        // Ενημέρωσε τη βάση με ότι αλλαγές έχουν γίνει στη φόρμα.
        this.store
            .dispatch(
                new DigitalClientCardGraphQLSchemaActions.Upsert(
                    digitalClientCard,
                    undefined,
                    this.dclCardService.digitalClientCardGQLQueryForEdit
                )
            )
            .pipe(
                concatMap(() => {
                    debugger;
                    const dclCard = this.store.selectSnapshot(
                        DigitalClientCardGraphQLSchemaSelectors.UpsertSelector(
                            '',
                            ''
                        )
                    )?.data?.Upsert;

                    // Φέρε το πρώτο παραστατικό που έχει έρθει επιτυχώς (InvoiceMark > 0). θα έχουμε πάντα ένα παραστατικό. Δεν υποστήρίζουμε 2 παραστατικά σε κάθε εγγραφή.
                    // (Όταν θα βάλουμε τη δυνατότητα να δένει 2 παραστατικά θα τα δένει από αλλού.)
                    const invoiceWithMark = dclCard?.Invoices?.find(
                        (invoice) => (invoice.Response?.InvoiceMark ?? 0) > 0
                    );

                    // Αν απαιτείται παραστατικό βάση του πεδίου ProvidedServiceCategory, τότε πρέπει να δούμε αν βρήκαμε κάποιο με _id
                    switch (digitalClientCard.ProvidedServiceCategory) {
                        case 1:
                        case 2:
                        case 3:
                            // Αν δεν υπάρχουν καθολού Παραστατικά τότε πρέπει να προσθέσουμε ένα. Οπότε ανοίγουμε τη φόρμα του νέου παρστατικού για να την ολοκληρώσει ο χρήστης.
                            if ((dclCard?.Invoices ?? []).length == 0) {
                                // ΠΡΟΣΟΧΗ: Όταν ανοίξει η φόρμα του νεόυ παραστατικού και ο χρήστης πατήσει έκδοση/διαβίβαση παραστατικού δίχως να έχει επιλέξει τρόπο πληρωμής
                                // το σύστημα πρέπει να του ζητήσει τρόπο πληρωμής και μετά να συνεχίσει στην έκδοση/διαβίβαση.
                                this.newInvoice(digitalClientCard, '11.2');

                                return of({
                                    data: {
                                        UpdateDigitalClientCard: undefined
                                    }
                                });
                            }

                            // Εδώ έχουμε δει ότι έχουμε τουλάχιστον ένα παραστατικό, οπότε να δούμε αν έχει ΜΑΡΚ. Αν δεν έχει πρέπει να ζητήσουμε από τον χρήστη να κάνει έκδοση παρστατικού.
                            // Για να ολοκληρωθεί σωστά μια εγγραφή ψηφιακού πελατολογίου τύπου 1 ή 2 ή 3 θα πρέπει να υπάρχει παραστατικό με ΜΑΡΚ.
                            // Το A.P.I του ψηφιακού πελατολογίου δεν κάνει έλεγχο αν ο χρήστης έχει καταχωρήσει το MARK, παρά μόνο αν έχει καταχωρήσει τον τύπο του παραστατικού
                            // που ΘΑ εκδόσει. Το παραστατικό μπορεί να εκδοθεί και σε 2ο χρόνο!!!!
                            if (invoiceWithMark == undefined) {
                                digitalClientCard.EntryCompletion = undefined;

                                // this.messageService.add({
                                //     summary: 'Μη έκδοση Φορολογικού Στοιχείου',
                                //     detail: "Δεν έχετε εκδώσει το απαραίτητο Φορολογικό Στοιχείο. Η 'Κατηγορία Παρεχόμενων Υπηρεσιών' που έχετε επιλέξει απαιτεί να εκδώσετε και να διαβιβάσετε στην Α.Α.Δ.Ε το ανάλογο παραστατικό.",
                                //     severity: 'error',
                                //     key: 'br'
                                // } as ToastMessageOptions);

                                // Άνοιξε τη φόρμα του 'ΠΡΩΤΟΥ' παραστατικού για να ολοκληρωθεί το παραστατικό.
                                this.editInvoice(digitalClientCard, 0);

                                return of(undefined);
                                // return of({
                                //     data: {
                                //         UpdateDigitalClientCard: undefined
                                //     }
                                // });
                            }
                            break;
                    }

                    // Αν είμαστε σε αυτό το σημείο τότε είναι ολα εντάξει (δηλαδή υπάρχει παραστατικό με ΜΑΡΚ) για να προχωρήσουμε στην ολοκλήρωση της εγγραφής του ψηφιακού πελατολογίου.
                    //
                    // ζητάμε από τον Server μας να καλέσει τo DCL/UpdateCLient (DCL_UpdateCLientAsync) endPoint της Α.Α.Δ.Ε με
                    // το πεδίο EntryCompletion = digitalClientCard.EntryCompletion.
                    digitalClientCard.EntryCompletion = true;
                    debugger;
                    return this.store
                        .dispatch(
                            // Ενημέρωσε πάλι την εγγραφή με το πεδίο EntryCompletion (Για έξοδο Οχήματος)
                            new DigitalClientCardGraphQLSchemaActions.Upsert(
                                digitalClientCard,
                                undefined,
                                this.dclCardService.digitalClientCardGQLQueryForEdit
                            )
                        )
                        .pipe(
                            concatMap(() => {
                                let updatedDigitalClientCard =
                                    this.store.selectSnapshot(
                                        DigitalClientCardGraphQLSchemaSelectors.UpsertSelector(
                                            '',
                                            ''
                                        )
                                    )?.data.Upsert ?? digitalClientCard;

                                console.debug(
                                    'Correlate Digital Client Card: ',
                                    updatedDigitalClientCard
                                );

                                debugger;
                                // Mε αυτή τη κλήση γίνεται η ολοκλήρωση της εγγραφής του ψηφιακού πελατολογίου στην Α.Α.Δ.Ε.
                                //
                                // Εδώ ο Server θα καλέσει τo DCL/UpdateCLient (DCL_UpdateCLientAsync) endPoint της Α.Α.Δ.Ε με
                                // το πεδίο EntryCompletion = digitalClientCard.EntryCompletion.
                                //
                                // Αυτό σημαίνει ότι αν το πεδίο αυτό δεν πάρει την τιμη 'true' δεν θα γίνει ποτέ η ολoκλήρωση της εγγραφής
                                // η οποία απλά θα γίνεται update.
                                //
                                // Η Συσχέτηση παραστατικού θα γίνει μετά.
                                return this.postDCLsToAADESchema
                                    .UpdateDigitalClientCard(
                                        updatedDigitalClientCard,
                                        this.dclCardService
                                            .digitalClientCardGQLQueryForEdit
                                    )
                                    .pipe(
                                        concatMap((digitalClientCard) => {
                                            // Ενημερωση χρήστη με το απότελεσμα της ολοκλήρωσης της εγγραφής του ψηφιακού πελατολογίου.
                                            this.validateDCLCompletion(
                                                digitalClientCard?.data
                                                    .UpdateDigitalClientCard,
                                                options
                                            );

                                            if (
                                                digitalClientCard?.data
                                                    ?.UpdateDigitalClientCard
                                                    ?.NonIssueInvoice == true
                                            )
                                                return of(digitalClientCard);

                                            debugger;
                                            // Εδώ γίνεται η συσχέτηση της εγγραφής του ψηφιακού πελατολογίου με ένα παραστατικό.
                                            // Αν δεν υπάρχει παραστατικό τότε δεν μπορεί να γίνει η συχέτηση.
                                            // (Το παραστατικό που θα δεθεί έχει ορισθεί κατά την αποθήκευση ή έκδοση του παραστατικού πριν φθάσει ο κώδικας εδώ).
                                            // ΠΡΟΣΟΧΗ: Η έκδοση του παραστατικού για συσχέτηση με το ψηφιακό πελατολόγιο δεν είναι σειρακές εργασίες.
                                            //          Το παραστατικό θα εκδοθεί όταν είναι να εκδοθεί, άνεξάρτητα με το ψηφιακό πελατολόγιο.
                                            //          Την πρώτη φορά που κάνει έξοδο οχήματος ο χρήστης δεν υπάρχει παραστατικό οπότε ο κώδικας φεύγει από αυτη τη μέθοδο και ζητάει του χρήστη να
                                            //          καταχωρήσει το παραστατικό και να το έκδοσει αν θέλει.
                                            //          Μετά την έκδοση του παραστατικού θα ξαναμπεί ο κώδικας σε αυτή τη μέθοδο οπότε και θα έρθει σε αυτό το σημείο με το ΜΑΡΚ του παραστατικού.
                                            //          Δεν υπάρχει περίπτωση να έρθει ο κώδικας εδώ αν δεν υπάρχει ΜΑΡΚ, αυτό το εξασφαλίζουμε στις πρώτες γραμμές της μεθόδου αυτής.
                                            return this.postDCLsToAADESchema
                                                .CorrelateDigitalClientCard(
                                                    digitalClientCard?.data
                                                        .UpdateDigitalClientCard,
                                                    invoiceWithMark,
                                                    this.dclCardService
                                                        .digitalClientCardGQLQueryForEdit
                                                )
                                                .pipe(
                                                    concatMap(
                                                        (
                                                            correlateDigitalClientCard
                                                        ) => {
                                                            this.validateDCLCorrelation(
                                                                correlateDigitalClientCard
                                                                    ?.data
                                                                    .CorrelateDigitalClientCard
                                                            );

                                                            return of(
                                                                correlateDigitalClientCard
                                                            );
                                                        }
                                                    )
                                                );

                                            // return of(digitalClientCard).pipe(
                                            //     concatMap(
                                            //         (
                                            //             digitalClientCard // correlateDigitalClientCardResponse
                                            //         ) => {
                                            //             // Συσχέτηση Παραστατικού

                                            //             if (digitalClientCard?.data?.UpdateDigitalClientCard?.NonIssueInvoice == true)
                                            //                 return of(digitalClientCard);

                                            //             // Εδώ γίνεται η συσχέτηση της εγγραφής του ψηφιακού πελατολογίου με ένα παραστατικό.
                                            //             // Αν δεν υπάρχει παραστατικό τότε δεν μπορεί να γίνει η συχέτηση.
                                            //             // (Το παραστατικό που θα δεθεί έχει ορισθεί κατά την αποθήκευση ή έκδοση του παραστατικού πριν φθάσει ο κώδικας εδώ).
                                            //             return this.postDCLsToAADESchema.CorrelateDigitalClientCard(
                                            //                 digitalClientCard
                                            //                     ?.data
                                            //                     .UpdateDigitalClientCard,
                                            //                 digitalClientCardGQLQueryForEdit
                                            //             );
                                            //         }
                                            //     )
                                            // );
                                        })
                                    );

                                // // Δες αν έχει ζητηθεί η μη έκδοση παραστατικού για να μη κάνει καμία συσχέτηση.
                                // // Προσοχή: Θεωρητικά, το επιτρέπει η Α.Α.Δ.Ε, να ορίσει ο χρήστης ότι δεν θέλει να εκδώσει παραστατικό!!!
                                // const nonIssueInvoice =
                                //     updatedDigitalClientCard.NonIssueInvoice;

                                // return (
                                //     nonIssueInvoice != true &&
                                //     updatedDigitalClientCard.EntryCompletion ==
                                //         true // Αν δεν είναι απαραίτητο το παραστατικό δεν συσχετίζεις παραστατικό.
                                //         ? // 2025/06/2025 Saridakis Antonis
                                //           // Mε αυτή τη κλήση γίνεται η ολοκλήρωση της εγγραφής του ψηφιακού πελατολογίου.
                                //           //
                                //           // Εδώ ο Server θα καλέσει τo DCL/UpdateCLient (DCL_UpdateCLientAsync) endPoint της Α.Α.Δ.Ε με
                                //           // το πεδίο EntryCompletion = digitalClientCard.EntryCompletion.
                                //           //
                                //           // Αυτό σημαίνει ότι αν το πεδίο αυτό δεν πάρει την τιμη 'true' δεν θα γίνει ποτέ η ολoκλήρωση της εγγραφής
                                //           // η οποία απλά θα γίνεται update.
                                //           //
                                //           // Η Συσχέτηση παραστατικού θα γίνει μετά.
                                //           this.postDCLsToAADESchema.UpdateDigitalClientCard(
                                //               updatedDigitalClientCard,
                                //               digitalClientCardGQLQueryForEdit
                                //           )
                                //         : of(undefined)
                                // ).pipe(
                                //     concatMap(
                                //         (
                                //             digitalClientCard // correlateDigitalClientCardResponse
                                //         ) => {
                                //             // εδώ μπορει να έχει έρθει

                                //             this.validateDCLCompletion(
                                //                 digitalClientCard?.data
                                //                     .UpdateDigitalClientCard
                                //             );

                                //             if (digitalClientCard == undefined)
                                //                 return of(undefined);

                                //             // Εδώ γίνεται η συσχέτηση της εγγραφής του ψηφιακού πελατολογίου με ένα παραστατικό.
                                //             // Αν δεν υπάρχει παραστατικό τότε δεν μπορεί να γίνει η συχέτηση.
                                //             // (Το παραστατικό που θα δεθεί έχει ορισθεί κατά την αποθήκευση ή έκδοση του παραστατικού πριν φθάσει ο κώδικας εδώ).
                                //             return this.postDCLsToAADESchema.CorrelateDigitalClientCard(
                                //                 digitalClientCard?.data
                                //                     .UpdateDigitalClientCard,
                                //                 digitalClientCardGQLQueryForEdit
                                //             );
                                //         }
                                //     )
                                // );
                            })
                        );
                }),
                finalize(() => this.loaderService.dismissAwaitLoader())
            )
            .subscribe((digitalCardType) => {
                debugger;
                // const lastResponse =
                //     digitalCardType?.data?.UpdateDigitalClientCard?.Responses?.sort(
                //         (a, b) => {
                //             const sort: number = 2; // 1 Ascending, 2 Descending
                //             if (a.ResponseDate == undefined)
                //                 return sort == 1 ? -1 : 1; // Ascending
                //             if (b.ResponseDate == undefined)
                //                 return sort == 1 ? 1 : -1; // Descending
                //             if (a.ResponseDate < b.ResponseDate)
                //                 return sort == 1 ? -1 : 1;
                //             if (a.ResponseDate > b.ResponseDate)
                //                 return sort == 1 ? 1 : -1;
                //             return 0;
                //         }
                //     )?.[0];
                // if (lastResponse?.Errors?.Error?.[0]?.Message != undefined) {
                //     this.messageService.add({
                //         summary: 'Αποτυχία ενημέρωσης Α.Α.Δ.Ε',
                //         detail: lastResponse?.Errors?.Error?.[0]?.Message ?? '',
                //         severity: 'error',
                //         key: 'br'
                //     } as ToastMessageOptions);
                // } else {
                //     if (digitalCardType?.data?.UpdateDigitalClientCard) {
                //         this.messageService.add({
                //             summary: 'Έξοδος Οχήματος',
                //             detail: 'Η εγγραφή οριστικοποιήθηκε επιτυχώς',
                //             severity: 'success',
                //             key: 'br'
                //         } as ToastMessageOptions);
                //         options.onSave(options);
                //     }
                // }
            });

        // // ζητάμε από τον Server μας να καλέσει τo DCL/UpdateCLient (DCL_UpdateCLientAsync) endPoint της Α.Α.Δ.Ε με
        // // // το πεδίο EntryCompletion = digitalClientCard.EntryCompletion.
        // digitalClientCard.EntryCompletion = true;

        // debugger;
        // switch (digitalClientCard.ProvidedServiceCategory) {
        //     case 1:
        //     case 2:
        //     case 3:
        //         //case 5: //TODO: Tcheck this Category !!!!!
        //         // this.dclFormGroup?.controls?.InvoiceKind?.setValue(
        //         //     undefined,
        //         //     { emitEvent: false }
        //         // );

        //         // Για να ολοκληρωθεί σωστά μια εγγραφή ψηφιακού πελατολογίου τύπου 1 ή 2 ή 3 θα πρέπει να υπάρχει παραστατικό με ΜΑΡΚ.
        //         // Το A.P.I του ψηφιακού πελατολογίου δεν κάνει έλεγχο αν ο χρήστης έχει καταχωρήσει το MARK, παρά μόνο αν έχει καταχωρήσει τον τύπο του παραστατικού
        //         // που ΘΑ εκδόσει. Το παραστατικό μπορεί να εκδοθεί και σε 2ο χρόνο!!!!
        //         if (digitalClientCard.InvoiceId == undefined) {
        //             digitalClientCard.EntryCompletion = undefined;

        //             this.messageService.add({
        //                 summary: 'Δεν βρέθηκε Φορολογικό Στοιχείο',
        //                 detail: "Δεν έχετε καταχωρήσει το απαραίτητο Φορολογικό Στοιχείο. Η 'Κατηγορία Παρεχόμενων Υπηρεσιών' που έχετε επιλέξει απαιτεί να εκδώσετε και να διαβιβάσετε στην Α.Α.Δ.Ε το ανάλογο παραστατικό.",
        //                 severity: 'error',
        //                 key: 'br'
        //             } as ToastMessageOptions);

        //             return;
        //         }
        //         break;
        // }

        // this.loaderService.showAwaitDataSaveLoader();

        // this.store
        //     .dispatch(
        //         new DigitalClientCardGraphQLSchemaActions.Upsert(
        //             digitalClientCard,
        //             undefined,
        //             digitalClientCardGQLQueryForEdit
        //         )
        //     )
        //     .pipe(
        //         concatMap(() => {
        //             let updatedDigitalClientCard =
        //                 this.store.selectSnapshot(
        //                     DigitalClientCardGraphQLSchemaSelectors.UpsertSelector(
        //                         '',
        //                         ''
        //                     )
        //                 )?.data.Upsert ?? digitalClientCard;

        //             console.debug(
        //                 'Correlate Digital Client Card: ',
        //                 updatedDigitalClientCard
        //             );

        //             const nonIssueInvoice =
        //                 updatedDigitalClientCard.NonIssueInvoice;

        //             // // Αν δεν υπάρχει δεμένο παραστατικό δημιούργησε ένα καινούριο
        //             // if (updatedDigitalClientCard.InvoiceId == undefined) {
        //             //     this.newInvoice(digitalClientCard, '11.2');
        //             //     return of({
        //             //         data: {
        //             //             UpdateDigitalClientCard:
        //             //                 updatedDigitalClientCard
        //             //         }
        //             //     });
        //             // }

        //             return (
        //                 nonIssueInvoice != true // Αν δεν είναι απαραίτητο το παραστατικό δεν συσχετήζεις παραστατικό.
        //                     ? // Εδώ γίνεται η συσχέτηση της εγγραφής του ψηφιακού πελατολογίου με ένα παραστατικό.
        //                       // Αν δεν υπάρχει παραστατικό τότε δεν μπορεί να γίνει η συχέτηση.
        //                       this.postDCLsToAADESchema.CorrelateDigitalClientCard(
        //                           updatedDigitalClientCard,
        //                           digitalClientCardGQLQueryForEdit
        //                       )
        //                     : of(undefined)
        //             ).pipe(
        //                 concatMap((digitalClientCardResponse) => {
        //                     // 2025/06/2025 Saridakis Antonis
        //                     // Mε αυτή τη κλήση γίνεται η ολοκλήρωση της εγγραφής του ψηφιακού πελατολογίου.
        //                     //
        //                     // Εδώ ο Server θα καλέσει τo DCL/UpdateCLient (DCL_UpdateCLientAsync) endPoint της Α.Α.Δ.Ε με
        //                     // το πεδίο EntryCompletion = digitalClientCard.EntryCompletion.
        //                     //
        //                     // Αυτό σημαίνει ότι αν το πεδίο αυτό δεν πάρει την τιμη 'true' δεν θα γίνει ποτέ η ολoκλήρωση της εγγραφής
        //                     // η οποία απλά θα γίνεται update.
        //                     return this.postDCLsToAADESchema.UpdateDigitalClientCard(
        //                         updatedDigitalClientCard,
        //                         digitalClientCardGQLQueryForEdit
        //                     );
        //                 })
        //             );
        //         }),
        //         finalize(() => this.loaderService.dismissAwaitLoader())
        //     )
        //     // .pipe(finalize(() => this.loaderService.dismissAwaitLoader()))
        //     .subscribe((digitalCardType) => {
        //         const lastResponse =
        //             digitalCardType?.data?.UpdateDigitalClientCard?.Responses?.sort(
        //                 (a, b) => {
        //                     const sort: number = 2; // 1 Ascending, 2 Descending
        //                     if (a.ResponseDate == undefined)
        //                         return sort == 1 ? -1 : 1; // Ascending

        //                     if (b.ResponseDate == undefined)
        //                         return sort == 1 ? 1 : -1; // Descending

        //                     if (a.ResponseDate < b.ResponseDate)
        //                         return sort == 1 ? -1 : 1;
        //                     if (a.ResponseDate > b.ResponseDate)
        //                         return sort == 1 ? 1 : -1;

        //                     return 0;
        //                 }
        //             )?.[0];

        //         if (lastResponse?.Errors?.Error?.[0]?.Message != undefined) {
        //             this.messageService.add({
        //                 summary: 'Αποτυχία ενημέρωσης Α.Α.Δ.Ε',
        //                 detail: lastResponse?.Errors?.Error?.[0]?.Message ?? '',
        //                 severity: 'error',
        //                 key: 'br'
        //             } as ToastMessageOptions);
        //         } else {
        //             options.onSave(options);
        //         }
        //     });

        // this.postDCLsToAADESchema
        //     .CorrelateDigitalClientCard(
        //         digitalClientCard,
        //         DigitalClientCardTypeQuery.GQLQuery()
        //     )
        //     .pipe(finalize(() => this.loaderService.dismissAwaitLoader()))
        //     .subscribe(() => {
        //         options.onSave(options);
        //     });
    }

    sendNewClient() {
        const options = this.dclCardsDialogConfig.data as DCLCardOptions;

        this.loaderService.showAwaitDataSaveLoader();

        const digitalClientCard =
            options.digitalClientCardTypeFormGroup?.getRawValue() as DigitalClientCardInputType;

        // όριζουμε από τη πρώτη στιγμή της εισόδου ότι η εργασία που θα κάνουμε έιναι η 1 (αυτή με τα ανταλλακτικά).
        digitalClientCard.ProvidedServiceCategory =
            digitalClientCard.ProvidedServiceCategory ?? 1;

        this.store
            .dispatch(
                new DigitalClientCardGraphQLSchemaActions.Upsert(
                    digitalClientCard,
                    undefined,
                    this.dclCardService.digitalClientCardGQLQueryForEdit
                )
            )
            .pipe(
                concatMap(() => {
                    let updatedDigitalClientCard =
                        this.store.selectSnapshot(
                            DigitalClientCardGraphQLSchemaSelectors.UpsertSelector(
                                '',
                                ''
                            )
                        )?.data.Upsert ?? digitalClientCard;

                    return this.postDCLsToAADESchema.NewDigitalClientCard(
                        updatedDigitalClientCard,
                        this.dclCardService.digitalClientCardGQLQueryForEdit
                    );
                }),
                finalize(() => this.loaderService.dismissAwaitLoader())
            )
            // .pipe(finalize(() => this.loaderService.dismissAwaitLoader()))
            .subscribe((digitalCardType) => {
                const lastResponse =
                    digitalCardType?.data?.NewDigitalClientCard?.Responses?.sort(
                        (a, b) => {
                            const sort: number = 2; // 1 Ascending, 2 Descending
                            if (a.ResponseDate == undefined)
                                return sort == 1 ? -1 : 1; // Ascending

                            if (b.ResponseDate == undefined)
                                return sort == 1 ? 1 : -1; // Descending

                            if (a.ResponseDate < b.ResponseDate)
                                return sort == 1 ? -1 : 1;
                            if (a.ResponseDate > b.ResponseDate)
                                return sort == 1 ? 1 : -1;

                            return 0;
                        }
                    )?.[0];

                if (lastResponse?.Errors?.Error?.[0]?.Message != undefined) {
                    this.messageService.add({
                        summary: 'Αποτυχία ενημέρωσης Α.Α.Δ.Ε',
                        detail: lastResponse?.Errors?.Error?.[0]?.Message ?? '',
                        severity: 'error',
                        key: 'br'
                    } as ToastMessageOptions);
                } else {
                    options.onDCLCardSave(options);
                }
            });

        // this.postDCLsToAADESchema
        //     .NewDigitalClientCard(
        //         digitalClientCard,
        //         DigitalClientCardTypeQuery.GQLQuery()
        //     )
        //     .pipe(finalize(() => this.loaderService.dismissAwaitLoader()))
        //     .subscribe(() => {
        //         options.onSave(options);
        //     });
    }

    /**
     * @deprecated
     * @param dclCard
     * @param invoiceTypeCode
     */
    newInvoice(dclCard: DigitalClientCardType, invoiceTypeCode: string) {
        const dialogRef = this.dialogService.open<InvoiceCardComponent>(
            InvoiceCardComponent,
            {
                header: 'Νέο Παραστατικό',
                height: '95vh',
                width: '95vw',
                modal: true,
                resizable: true,
                draggable: true,
                closeOnEscape: false,
                closable: true,
                focusOnShow: false,
                maximizable: true,

                // dclId: dclCard?._id,
                // dclCard: dclCard,
                // invoiceTypeCode: invoiceTypeCode,
                templates: {
                    footer: InvoiceCardFooterComponent
                },
                data: {
                    mode: 'add',
                    sourceModal: true,
                    dclId: dclCard?._id,
                    dclCard: dclCard,
                    DCLInvoiceTypeCode: invoiceTypeCode,
                    onSave: (options: InvoiceOptions) => {
                        dialogRef.close();
                        console.debug(
                            'Saved & Complete from DCL Card (New Invoice)'
                        );

                        // Να ενημερώσουμε τη λίστα με τις καρτέλες του DCL να κλείσει το modal του DCL Card και να κάνει Refresh
                        const dclCardsOptions = this.dclCardsDialogConfig
                            .data as DCLCardOptions;
                        dclCardsOptions.onDCLCardSave(dclCardsOptions);

                        // if (this.event) this.onLazyLoad(this.event);
                    },
                    onDoPOSTransaction: (
                        options: InvoiceOptions,
                        lastSalePOSTransaction:
                            | POSTerminalTransactionType
                            | undefined,
                        POSResponse: POSTerminalResponseType | undefined
                    ) => {
                        dialogRef.close();
                        // Τώρα οριστικοποίησε την εγγραφή γιατί ολοκληρώθηκε επιτυχώς η διαβίβαση του παραστατικού που έγινε σε 2ο χρόνο γιατί είχε ζητηθεί πληρωμή με κάρτα.
                        //this.completeDCL();
                        this.completeDCL2();
                    },
                    onSentToAADE: (
                        options: InvoiceOptions,
                        invoice: InvoiceType
                    ) => {
                        dialogRef.close();

                        // δώσε λίγο χρόνο για να κάνει refresh το UI και να κλείσει τα Modals που έχει ανοιχτά.
                        timer(300).subscribe(() => {
                            // Τώρα οριστικοποίησε την εγγραφή γιατί ολοκληρώθηκε επιτυχώς η διαβίβαση του παραστατικού.
                            // Εδώ έρχεται όταν δεν επιλέξει πληρωμή με κάρτα ο χρήστης και είμαστε σε νέο παραστατικό μέσα από το DCL Card και το κουμπάκι έξοδος.
                            //this.completeDCL();
                            this.completeDCL2();
                        });

                        // const dclOptions = this.dialogConfig as DCLCardOptions;
                        // dclOptions.onSave(dclOptions);

                        // if (this.event) this.onLazyLoad(this.event);
                    }
                }
            } as DynamicDialogConfig<InvoiceOptions>
        );

        //dialogRef.onClose
    }

    /**
     * @deprecated
     * @param dclCard
     * @param index
     */
    editInvoice(dclCard: DigitalClientCardType, index: number) {
        const dialogRef = this.dialogService.open<InvoiceCardComponent>(
            InvoiceCardComponent,
            {
                header: 'Παραστατικό',
                height: '95vh',
                width: '95vw',
                modal: true,
                resizable: true,
                draggable: true,
                closeOnEscape: false,
                closable: true,
                focusOnShow: false,
                maximizable: true,
                // dclId: dclCard?._id,
                // dclCard: dclCard,
                // invoiceTypeCode: dclCard.Invoices?.[index]?.TypeCode,
                // invoiceType: dclCard.Invoices?.[index],

                templates: {
                    footer: InvoiceCardFooterComponent
                },
                data: {
                    mode: 'edit',
                    sourceModal: true,
                    dclId: dclCard?._id,
                    dclCard: dclCard,
                    DCLInvoiceTypeCode: dclCard.Invoices?.[index]?.TypeCode,
                    invoiceType: dclCard.Invoices?.[index],
                    onSave: (options: InvoiceOptions) => {
                        console.debug(
                            'Saved & Complete from DCL Card Completion (EditInvoice)'
                        );
                        dialogRef.close();
                        // Να ενημερώσουμε τη λίστα με τις καρτέλες του DCL να κλείσει το modal του DCL Card και να κάνει Refresh
                        const dclCardsOptions = this
                            .dclCardsDialogConfig as DCLCardOptions;
                        dclCardsOptions.onDCLCardSave(dclCardsOptions);
                        //if (this.event) this.onLazyLoad(this.event);
                    },
                    onDoPOSTransaction: (
                        options: InvoiceOptions,
                        lastSalePOSTransaction:
                            | POSTerminalTransactionType
                            | undefined,
                        POSResponse: POSTerminalResponseType | undefined
                    ) => {
                        dialogRef.close();
                        // Τώρα οριστικοποίησε την εγγραφή γιατί ολοκληρώθηκε επιτυχώς η διαβίβαση του παραστατικού που έγινε σε 2ο χρόνο γιατί είχε ζητηθεί πληρωμή με κάρτα.
                        //this.completeDCL();
                        this.completeDCL2();
                    },
                    onSentToAADE: (
                        options: InvoiceOptions,
                        invoice: InvoiceType
                    ) => {
                        console.debug(
                            'send to aade  from DCL Card Completion !!!'
                        );
                        dialogRef.close();
                        timer(300).subscribe(() => {
                            // Τώρα οριστικοποίησε την εγγραφή γιατί ολοκληρώθηκε επιτυχώς η διαβίβαση του παραστατικού.
                            // Εδώ έρχεται όταν δεν επιλέξει πληρωμή με κάρτα ο χρήστης και είμασε σε μεταβολή παραστατικού.
                            //this.completeDCL();
                            this.completeDCL2();
                        });

                        // if (this.event) this.onLazyLoad(this.event);
                    }
                }
            } as DynamicDialogConfig<InvoiceOptions>
        );
    }
    ngOnDestroy() {
        this.destroySubject.next(true);
        this.destroySubject.complete();
    }
}

const entitySubjectInfoTypeQuery = EntitySubjectInfoTypeQuery.GQLQuery({
    SubjectsToCustomers: CustomersToEntitiesSubjectTypeQuery.GQLQuery({
        Customer: CustomerTypeQuery.GQLQuery({
            ...CustomerTypeQuery.GQLQuery(),
            Addresses: AddressTypeQuery.GQLQuery({
                City: CityTypeQuery.GQLQuery()
            }),
            FirstName: FirstNameTypeQuery.GQLQuery(),
            FatherName: FirstNameTypeQuery.GQLQuery(),
            InfoNotes: InfoNoteTypeQuery.GQLQuery(),
            OccupationActivity: OccupationActivityTypeQuery.GQLQuery(),
            ContactDetails: ContactDetailTypeQuery.GQLQuery({
                Address: AddressTypeQuery.GQLQuery({
                    City: CityTypeQuery.GQLQuery()
                })
            }),
            // Courier: CourierTypeQuery.GQLQuery(),
            FinancialDetails: FinancialDetailTypeQuery.GQLQuery(),
            TraderProfitMargin: TraderProfitMarginTypeQuery.GQLQuery(),
            CTAXOffice: TAXOfficeTypeQuery.GQLQuery(),
            Subjects: CustomersToEntitiesSubjectTypeQuery.GQLQuery({
                Subject: EntitySubjectInfoTypeQuery.GQLQuery()
            })
        })
    })
});
// const digitalClientCardGQLQueryForEdit = DigitalClientCardTypeQuery.GQLQuery({
//     Garage: DCLGarageUseTypeQuery.GQLQuery(),
//     RentalUse: DCLRentalUseTypeQuery.GQLQuery(),
//     ParkingUse: DCLParkingCarWashUseTypeQuery.GQLQuery(),
//     Invoices: InvoiceTypeQuery.GQLQuery({
//         Response: ProviderResponseTypeQuery.GQLQuery(),
//         Responses: ProviderResponseTypeQuery.GQLQuery(),
//         DCLCorrelationResponse: DCLResponseTypeQuery.GQLQuery({
//             Errors: ResponseTypeErrorTypeQuery.GQLQuery({
//                 Error: ProviderResponseErrorTypeQuery.GQLQuery()
//             })
//         })
//     }),
//     Responses: DCLResponseTypeQuery.GQLQuery({
//         Errors: ResponseTypeErrorTypeQuery.GQLQuery({
//             Error: ProviderResponseErrorTypeQuery.GQLQuery()
//         }),
//         DCLCorrelations: DCLCorrelationTypeQuery.GQLQuery(),
//         UsersActions: UsersActionsTypeQuery.GQLQuery()
//     })
// });
